import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips",
  style: {"margin-bottom":"6px"}
}
const _hoisted_3 = {
  class: "bi-tmpl-detail__right__cmpt__title",
  style: {"margin-top":"0"}
}
const _hoisted_4 = ["onClick"]

import { ref } from 'vue';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleSex from '../../../../../bi-pc-module/pc-module-sex-distribution/index';

const CHILD_KEY = '4_2_1';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-4-2-1',
  setup(__props) {

const TYPE_MAPPING = [1, 2, 3, 4, 5, 6, 7].map(i => {
  return {
    value: 'pc-module-sex-distribution-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleSex.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, state } = useDetailCmpt({ childKey: CHILD_KEY });

const colorList = ref(
  state.value.menuValue.get('101').value['101_1'].value.split(',')
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(curItem).tips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(curItem).title), 1)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 200,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"height":"200px","width":"100%"},
            key: index,
            onClick: ($event: any) => (_unref(onChange)(item.value))
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"200px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  value: item.value,
                  "model-value": _unref(curItem).value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), {
                      colorList: colorList.value,
                      style: {"margin-top":"20px"}
                    }, null, 8, ["colorList"]))
                  ]),
                  _: 2
                }, 1032, ["value", "model-value"])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_4))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})